import Vue from 'vue'
import { pipe, filter, forEach, map, has } from 'ramda'

// This function makes sure two things:
// - that TranslationInfo.Translations has all the keys from AvailableCultures
// - that each object in TranslationInfo.Translations has all the keys from TranslatableFields
export default function completeTranslationInfo(model) {
  if (!model.TranslationInfo) {
    Vue.set(model, 'TranslationInfo', { Translations: {} })
  } else {
    // This function sets missing fields
    const completeFields = model =>
      pipe(
        filter(field => !has(field, model)),
        forEach(field => Vue.set(model, field, null)),
      )
    // This pipe gets Names from available cultures, and completes all models in Translations
    pipe(
      map(ac => ac.Name),
      forEach(code => {
        const existing = model.TranslationInfo.Translations[code]
        if (!existing) {
          Vue.set(model.TranslationInfo.Translations, code, {})
        }
        const translationModel = model.TranslationInfo.Translations[code]
        completeFields(translationModel)(model.TranslationInfo.TranslatableFields)
      }),
    )(model.TranslationInfo.AvailableCultures)
  }
}
